import React, { useState, useContext } from "react";
import { HttpService } from "../../apiAuthorization/httpService";
import { OfflineService } from "../../offline/storageService/offlineService";
import { Context } from "../contexts/siteContext";

export const AssignedToUsers = React.createContext(null);

export const AssignedToUsersContext = props => {
    const offlineService = new OfflineService();
    const { defaultSite } = useContext(Context);
    const [assignedUsers, setAssignedUsers] = useState([]);

    const getAssignedToUsers = () => {
        HttpService.post('/Home/GetAssignedTo', {
            houseCode: defaultSite.houseCode.toString()
        })
        .then(async (result) => {
            if (result && result.offline) {
                //get offline data
                const offlineResult = await offlineService.getOfflinesBySite(defaultSite.id, "AssignedTo");
                result = offlineResult.OfflineData;
            }
            setAssignedUsers(result);
        },
        (error) => {
            console.log(error);
        });
    }

    return (
        <>
            <AssignedToUsers.Provider value={{ assignedUsers, getAssignedToUsers }}>
                {props.children}
            </AssignedToUsers.Provider>
        </>
    );
}
